import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const Tarifs = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="text-center mb-10">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">
                        Tarifs et Remboursements
                    </h1>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4' style={{ borderColor: Helper.footerBackGroundColor }}></div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <h2 className="font-bold text-xl sm:text-2xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Première consultation</h2>
                        <p className="text-3xl font-bold text-center mb-6" style={{ color: Helper.contentLetterColor }}>70€</p>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Échange et questions sur l'historique du patient (anamnèse)</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Examen postural (rachidien)</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Examen neurologique</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Ajustements</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Conseils et exercices</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <h2 className="font-bold text-xl sm:text-2xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Consultation de suivi</h2>
                        <p className="text-3xl font-bold text-center mb-6" style={{ color: Helper.contentLetterColor }}>65€</p>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Échange sur l'historique du patient</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Échange sur l'évolution des symptômes</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Examens</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Ajustements</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Conseils et exercices</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <h2 className="font-bold text-xl sm:text-2xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Étudiants & Partenariats</h2>
                        <p className="text-3xl font-bold text-center mb-6" style={{ color: Helper.contentLetterColor }}>55€</p>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Échange sur l'évolution des symptômes</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Examens</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Ajustements</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Conseils et exercices</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <h2 className="font-bold text-xl sm:text-2xl text-center mb-4" style={{ color: Helper.footerBackGroundColor }}>Remboursement</h2>
                        <div className="space-y-4 text-sm sm:text-base text-gray-600 leading-relaxed">
                            <p>En France, les actes des chiropracteurs ne sont pas remboursés par la sécurité sociale.</p>
                            <p>Néanmoins, de plus en plus de complémentaires santé proposent des contrats intégrant une prise en charge des soins chiropratiques.</p>
                            <p className="font-semibold text-gray-800">Prenez contact avec votre mutuelle pour connaître les modalités de remboursement.</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <h2 className="font-bold text-xl sm:text-2xl text-center mb-4" style={{ color: Helper.footerBackGroundColor }}>Modes de règlement</h2>
                        <ul className="space-y-3 text-sm sm:text-base text-gray-600">
                            <li className="flex items-center gap-3">
                                <span className="text-green-500 text-lg">✓</span>
                                <span>Carte bancaire</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <span className="text-green-500 text-lg">✓</span>
                                <span>Espèces</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex justify-center mt-10">
                    <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                        Prendre rendez-vous
                    </button>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
